


































import Vue from 'vue';
import { isGameLost, isGameWon } from '@/game/scoring';
import Help from '@/components/Help.vue';

export default Vue.component('Goal', {
  props: ['game', 'giveUp', 'startNewGame'],
  components: {
    Help
  },
  computed: {
    gameOver() {
      return isGameWon(this.$props.game) || isGameLost(this.$props.game);
    }
  }
});
